export enum LegalDocumentTypeEnum {
    None = 0,
    BusinessPermit = 1,
    BIR2303 = 2
}
